

export const index = 6;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(app)/(marketing)/about/_page.svx.js')).default;
export const imports = ["_app/immutable/nodes/6.h_xdFFBX.js","_app/immutable/chunks/NZTpNUN0.js","_app/immutable/chunks/p3uxj6nt.js","_app/immutable/chunks/DNEeYo6t.js"];
export const stylesheets = [];
export const fonts = [];
